/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Cta_DescInputs */

const en_rd_cta_desc = /** @type {(inputs: Rd_Cta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep reads the same repo and turns it into a PRD, tasks and pass/fail criteria — then makes your agent prove every one of them.`)
};

const id_rd_cta_desc = /** @type {(inputs: Rd_Cta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep membaca repo yang sama lalu mengubahnya jadi PRD, task, dan kriteria lulus/gagal — dan menuntut agent-mu membuktikan tiap kriterianya.`)
};

/**
* | output |
* | --- |
* | "Bystep reads the same repo and turns it into a PRD, tasks and pass/fail criteria — then makes your agent prove every one of them." |
*
* @param {Rd_Cta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_cta_desc = /** @type {((inputs?: Rd_Cta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Cta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_cta_desc(inputs)
	return en_rd_cta_desc(inputs)
});